import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import {formatTelefone} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class DetalhamentoJustificativaExcecao extends Component {

    static propTypes = {
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;
        return (
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Justificativa para a solicitação de exceção</Label>
                        <Input type="textarea" value={_.get(solicitacao, "justificativaExcecao")} readOnly />
                    </FormGroup>
                </Col>
            </Row>
        )
    }
}